export default "__VITE_ASSET__Ca7s4Hp4__"